import React, { Component, PropTypes } from 'react';
import { Divider } from 'material-ui';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { push as routerPush } from 'react-router-redux';
import { getConversations, markRead } from './store/actions';
import ContentMessage from './content-message';
import Comment from './content-comment';
import NoteContent from '../../components/notes/note-content';
import ChannelList from './channel-list';
import injectSheet from 'react-jss';
import WallWrapper from '../wall/wrapper';

const styles = {
  content: {
    backgroundColor: 'rgb(240, 244, 247)',
    height: '100%',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  activities: {
    backgroundColor: 'white',
    flex: '1 1 auto',
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: '8px 2%',
  },
};

class WorkspaceContent extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.scrollToBottom();
    if (!this.timer) this.timer = setInterval(this.timedUpdate, 3e3);
    // trigger because the container might not need scrolling
    this.onScroll({ target: this.conversationDOM() });
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.loading && !nextProps.loading && nextProps.body.length !== this.props.body.length) {
      this.scrollToBottom();
    } else if (this.props.selectedChannel !== nextProps.selectedChannel || this.props.selectedConnection !== nextProps.selectedConnection) {
      // the user might had switched channels, and the container might not need scrolling
      this.onScroll({ target: this.conversationDOM() });
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  onScroll = ({ target }) => {
    if (target.scrollTop === (target.scrollHeight - target.clientHeight)) {
      this.props.markRead();
    }
  }
  conversationDOM = () => document.getElementsByClassName('conversation')[0];
  scrollToBottom = debounce(() => {
    const container = this.conversationDOM();
    if (container) container.scrollTop = (container.scrollHeight - container.clientHeight);
  }, 100);
  timedUpdate = () => {
    if (!localStorage.stopAutoReload && !this.props.loading) this.props.getConversations();
  }
  timer = null
  render() {
    const { body, selectedChannel, selectedContract, classes, partnerLocked } = this.props;
    const showCommentBox = selectedChannel && (
      selectedChannel !== 'contracting' &&
      selectedContract !== 'contracting'
    ) && !partnerLocked;
    return (
      <div className={`${this.props.className || ''} ${classes.content}`}>
        <ChannelList />
        <div className={`conversation ${classes.activities}`} onScroll={this.onScroll}>
          { body
            .filter(message => message.text)
            .map(message => (message.type === 'note') ? <NoteContent
              itemId={message.key}
              bodyText={message.text}
              attachments={message.attachments}
              authorname={message.participant.name}
              timestamp={message.timestamp}
              handleRemove={(key) => { console.log(key); }}
            /> : <ContentMessage {...message} />)}
        </div>
        <Divider />
        { showCommentBox && <Comment {...(selectedChannel === 'notes' ? { internal: true } : {})}/> }
        {
          Boolean(partnerLocked) && (
            <WallWrapper
              amazonOrange
              slug="upgrade-page-lkd-partners"
              blocker
              skipBack
            >
              <div
                style={{ position: 'relative' }}
              >
                <div
                  style={{
                    position: 'absolute',
                    height: '300px',
                    width: '100%',
                    backgroundColor: 'rgba(255, 193, 7, 0.5)',
                    fontSize: '24px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    paddingTop: '2em',
                  }}
                >
                  This partner is locked.
                  <br/>
                  <br/>
                  Upgrade to Interact
                </div>
                <Comment/>
              </div>
            </WallWrapper>
          )
        }
      </div>
    );
  }
}
WorkspaceContent.defaultProps = {
  conversationCommentHeight: 205,
};

WorkspaceContent.propTypes = {
  body: PropTypes.array,
  classes: PropTypes.object,
  className: PropTypes.string,
  contractId: PropTypes.string,
  conversationCommentHeight: PropTypes.number,
  getConversations: PropTypes.func,
  loading: PropTypes.bool,
  markRead: PropTypes.func,
  participanName: PropTypes.string,
  routerPush: PropTypes.func,
  selectedChannel: PropTypes.string,
  selectedConnection: PropTypes.string,
  selectedContract: PropTypes.string,
  partnerLocked: PropTypes.bool,
};

const select = (state) => ({
  body: state.workspace.conversations,
  partnerLocked: state.workspace.partnerLocked,
  contractId: state.workspace.conversationsContractId,
  loading: state.workspace.conversationsFetching,
  participanName: state.workspace.conversationsParticipantName,
  selectedChannel: state.workspace.selectedChannel,
  selectedConnection: state.workspace.selectedConnection,
  selectedContract: state.workspace.selectedContract,
});

export default connect(select, {
  getConversations,
  markRead,
  routerPush,
})(injectSheet(styles)(WorkspaceContent));
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/components/workspace/content.jsx